import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "d-flex justify--center mt-3" }

import { computed, reactive, ref } from "vue";
import { AuthService } from '@/codes/services/AuthService';
import { useStore } from 'vuex';
import router from "@/router";
import { LoginInput } from "@/codes/gen/types";
import { VUEX_ACTIONS } from "@/codes/util/constants";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref('');
const password = ref('');
const emailErrors = reactive({ errors: [] as Array<string> });
const passwordErrors = reactive({ errors: [] as Array<string> });
const store = useStore();
const formReady = computed(() => {
  return !emailErrors.errors.length && !passwordErrors.errors.length
});
async function onsubmit() {
  emailErrors.errors = email.value ? [] : ['Email is required'];
  passwordErrors.errors = password.value ? [] : ['Password is required'];
  if (!formReady.value) {
    return;
  }
  const service = new AuthService();
  const loginInput: LoginInput = {
    username: email.value,
    password: password.value
  };
  const response = await service.login(loginInput);
  store.dispatch(VUEX_ACTIONS.setAuthToken, response?.accessToken);
  if (router.currentRoute.value.query && router.currentRoute.value.query.returnUrl && router.currentRoute.value.query.returnUrl !=='/auth/login') {
    router.push(router.currentRoute.value.query.returnUrl.toString());
  }
  else {
    router.push({ name: 'home' });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(onsubmit, ["prevent"])
  }, [
    _createVNode(_component_va_input, {
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (email.value = $event)),
      class: "mb-3",
      type: "email",
      label: _ctx.$t('auth.email'),
      error: !!_unref(emailErrors).errors.length,
      "error-messages": _unref(emailErrors).errors
    }, null, 8, ["modelValue", "label", "error", "error-messages"]),
    _createVNode(_component_va_input, {
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (password.value = $event)),
      class: "mb-3",
      type: "password",
      label: _ctx.$t('auth.password'),
      error: !!_unref(passwordErrors).errors.length,
      "error-messages": _unref(passwordErrors).errors
    }, null, 8, ["modelValue", "label", "error", "error-messages"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_button, {
        class: "my-0",
        onClick: onsubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('auth.login')), 1)
        ]),
        _: 1
      })
    ])
  ], 40, _hoisted_1))
}
}

})